(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dna-gift-shopping"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  const selector = event.target;
  if (!(selector instanceof HTMLSelectElement) || !selector.matches('[data-gift-select]')) return;
  const card = selector.closest('[data-gift-card]');
  const option = selector.selectedOptions[0];
  if (!card || !option) return;
  const price = card.querySelector('[data-gift-price]');
  const button = card.querySelector('[data-gift-submit]');
  const image = card.querySelector('.dna-gift-shop__image');
  if (price) price.textContent = option.dataset.price;
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
  }
  card.querySelectorAll('[data-gift-link]').forEach((link) => { link.href = option.dataset.url; });
  if (image && option.dataset.image) {
    image.srcset = option.dataset.srcset;
    image.src = option.dataset.image;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dna-instafeed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const findMount = () => document.querySelector('[data-dna-instafeed]');

    const updateTitle = () => {
      const mount = findMount();
      if (mount) window.instafeedLocalTitle = mount.dataset.instafeedTitle;
      return mount;
    };

    const ensureScript = () => {
      const mount = updateTitle();
      if (!mount) return;

      const source = new URL(mount.dataset.instafeedScript, document.baseURI);
      const alreadyIncluded = Array.from(document.scripts).some((script) => {
        if (!script.src) return false;
        try {
          const existing = new URL(script.src, document.baseURI);
          return existing.origin === source.origin && existing.pathname === source.pathname;
        } catch (_) {
          return false;
        }
      });
      if (alreadyIncluded) return;

      const script = document.createElement('script');
      script.src = source.href;
      script.async = true;
      document.body.appendChild(script);
    };

    updateTitle();
    if (document.readyState === 'complete') ensureScript();
    else window.addEventListener('load', ensureScript, { once: true });

    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target.querySelector('[data-dna-instafeed]')) return;
      updateTitle();
      if (document.readyState === 'complete') ensureScript();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dna-mini-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
  const parseCounts = sku => {
    const match = /^DNA-MB-C(\d+)-G(\d+)-P(\d+)-L(\d+)-T(\d+)$/.exec(sku || '');
    return match ? match.slice(1).map(Number) : null;
  };
  const keyFor = slots => {
    const counts = [0, 0, 0, 0, 0];
    slots.forEach(item => { if (Number.isInteger(item) && item >= 0 && item < 5) counts[item]++; });
    return 'DNA-MB-' + counts.map((n, i) => ['C', 'G', 'P', 'L', 'T'][i] + n).join('-');
  };
  const itemCount = slots => slots.filter(i => Number.isInteger(i) && i >= 0).length;
  const complete = slots => slots[0] !== null && slots[0] >= 0 && slots[1] !== null && slots[1] >= 0 && slots.every(i => i !== null);
  function mount(root) {
    if (root.dataset.mounted === 'true') return;
    const node = root.querySelector('[data-config]');
    let cfg;
    try { cfg = JSON.parse(node.textContent); } catch (_) { return; }
    root.dataset.mounted = 'true';
    const s = cfg.strings;
    const items = cfg.items;
    const raw = cfg.variants;
    const variants = new Map(raw.skus.map((sku, i) => [sku, {id: String(raw.ids[i]), price: Number(raw.prices[i]), available: Boolean(raw.available[i]), counts: parseCounts(sku)}]));
    const one = selector => root.querySelector(selector);
    const all = selector => [...root.querySelectorAll(selector)];
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style: 'currency', currency: cfg.currency || 'AUD'});
    const format = cents => money.format(cents / 100);
    const basePrices = cfg.retailPrices;
    const headings = [s.step_one, s.step_two, s.step_three, s.step_four];
    const artworks = all('[data-choice]').map(button => button.querySelector('.dna-mini-art'));
    const originalLabel = cfg.isDraft ? s.review : s.add_to_cart;
    let slots = [null, null, null, null];
    let active = 0;
    let busy = false;
    const variantFor = selection => variants.get(keyFor(selection));
    const make = (tag, className, text) => {
      const el = document.createElement(tag);
      if (className) el.className = className;
      if (text !== undefined) el.textContent = text;
      return el;
    };
    function feedback(message, isError = false) {
      one('[data-feedback]').textContent = message;
      one('[data-feedback]').classList.toggle('is-error', isError);
    }
    function focusHeading() {
      const heading = active < 4 ? one('[data-step-heading]') : one('[data-ready-heading]');
      requestAnimationFrame(() => {
        const header = document.querySelector('.header__wrapper');
        const announcement = document.querySelector('[aria-label="Store announcements"]');
        const offset = Math.max(24, header ? header.offsetHeight : 0) + (announcement ? announcement.offsetHeight : 0) + 20;
        const scrollTarget = active < 4 ? one('[data-step="' + Math.max(0, active - 1) + '"]') : heading;
        scrollTarget.style.scrollMarginTop = offset + 'px';
        heading.focus({preventScroll: true});
        scrollTarget.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      });
    }
    function canReachAvailable(selection) {
      if (cfg.isDraft) return true;
      const counts = [0, 0, 0, 0, 0];
      selection.forEach(i => { if (Number.isInteger(i) && i >= 0) counts[i]++; });
      const openSlots = selection.filter(i => i === null).length;
      return [...variants.values()].some(variant => {
        if (!variant.available || !variant.counts) return false;
        const count = variant.counts.reduce((sum, n) => sum + n, 0);
        if (count < 2 || count > 4) return false;
        const missing = variant.counts.reduce((sum, n, i) => sum + n - counts[i], 0);
        return variant.counts.every((n, i) => n >= counts[i]) && missing >= 0 && missing <= openSlots;
      });
    }
    function advance() {
      const next = slots.findIndex(value => value === null);
      active = next === -1 ? 4 : next;
      render();
      focusHeading();
    }
    function choose(item) {
      if (busy || active >= 4 || (item === -1 && active < 2)) return;
      const next = slots.slice();
      next[active] = item;
      if (!canReachAvailable(next)) return;
      slots = next;
      advance();
    }
    function updateUrl(variant) {
      const url = new URL(window.location.href);
      if (variant && complete(slots)) url.searchParams.set('variant', variant.id);
      else url.searchParams.delete('variant');
      window.history.replaceState({}, '', url);
    }
    function renderPreview() {
      const bottles = one('[data-bottles]');
      const count = itemCount(slots);
      one('[data-preview-count]').textContent = count + ' / 4';
      bottles.hidden = count === 0;
      bottles.dataset.count = String(count);
      one('[data-empty-preview]').hidden = count !== 0;
      bottles.replaceChildren();
      slots.forEach((item, index) => {
        if (item === null || item < 0) return;
        const figure = make('figure', 'dna-mb__bottle');
        const artwork = artworks[item].cloneNode(true);
        figure.append(artwork, make('figcaption', '', items[item].name));
        bottles.append(figure);
      });
    }
    function render() {
      const count = itemCount(slots);
      const done = complete(slots);
      const variant = variantFor(slots);
      const available = Boolean(variant && (cfg.isDraft || variant.available));
      const chooser = one('[data-chooser]');
      chooser.hidden = active >= 4;
      one('[data-ready]').hidden = active < 4;
      one('[data-options]').classList.toggle('has-skip', active >= 2);
      one('[data-skip]').hidden = active < 2;
      const panels = all('[data-step-panel]');
      if (active < 4 && chooser.parentElement !== panels[active]) panels[active].append(chooser);
      all('[data-step]').forEach((button, i) => {
        const locked = slots.slice(0, i).some(n => n === null);
        const selected = slots[i] !== null;
        const expanded = i === active;
        const row = button.closest('[data-step-row]');
        row.hidden = locked;
        row.classList.toggle('is-complete', selected);
        row.classList.toggle('is-active', expanded);
        panels[i].hidden = !expanded;
        button.disabled = busy || locked;
        button.setAttribute('aria-expanded', String(expanded));
        if (expanded) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current');
        const name = !selected ? s.not_chosen : slots[i] < 0 ? s.empty : items[slots[i]].name;
        button.querySelector('[data-step-summary]').textContent = selected ? name : s.step_label + ' ' + (i + 1);
        button.querySelector('[data-step-change]').hidden = !selected || expanded;
        button.querySelector('[data-step-check]').hidden = !selected || expanded || slots[i] < 0;
        button.setAttribute('aria-label', s.step_label + ' ' + (i + 1) + ': ' + name);
      });
      if (active < 4) {
        one('[data-step-heading]').textContent = headings[active];
        one('[data-step-tag]').textContent = active < 2 ? s.required : s.optional;
        one('[data-step-hint]').textContent = [s.choose_hint,s.second_hint,s.third_hint,s.fourth_hint][active];
        all('[data-choice]').forEach((button, i) => {
          const next = slots.slice();next[active] = i;
          button.disabled = busy || !canReachAvailable(next);
          button.setAttribute('aria-pressed', slots[active] === i ? 'true' : 'false');
          button.setAttribute('aria-label', s.choose + ' ' + items[i].name + (button.disabled ? ' · ' + s.stock_notice : ''));
        });
        const next = slots.slice();next[active] = -1;
        one('[data-skip]').disabled = busy || !canReachAvailable(next);
        one('[data-skip]').setAttribute('aria-pressed', slots[active] === -1 ? 'true' : 'false');
      }
      one('[data-total]').textContent = format(variant?.price || 0);
      const retail = slots.reduce((sum, i) => sum + (i !== null && i >= 0 ? basePrices[i] : 0), 0);
      const retailKnown = slots.every(i => i === null || i < 0 || basePrices[i] > 0);
      const saving = variant && retailKnown ? Math.max(0, retail - variant.price) : 0;
      one('[data-saving-row]').hidden = saving <= 0;
      one('[data-saving]').textContent = format(saving);
      const submit = one('[data-submit]');
      submit.disabled = busy || count < 2 || !available;
      submit.textContent = busy ? s.adding : count < 2 ? s.choose_required : !done ? s.finish_now.replace('{count}',String(count)) : originalLabel;
      one('[data-variant-id]').value = done && variant ? variant.id : '';
      one('[data-variant-id]').disabled = !done || !available;
      one('[data-reset]').hidden = slots.every(i => i === null);
      one('[data-reset]').disabled = busy;
      renderPreview();
      feedback(count < 2 ? s.choose_two : !done ? s.finish_choices : !available ? s.unavailable : '');
      updateUrl(done ? variant : null);
    }
    function review() {
      const list = one('[data-review-list]');list.replaceChildren();
      slots.forEach((i, index) => {if (i >= 0 && i !== null) list.append(make('li', '', (index + 1) + '. ' + items[i].name + ' · ' + (items[i].format === 'mini' ? s.mini_format : s.can_format)));});
      one('[data-review-total]').textContent = format(variantFor(slots).price);
      one('[data-dialog]').showModal();
    }
    all('[data-choice]').forEach((button, i) => button.addEventListener('click', () => choose(i)));
    one('[data-skip]').addEventListener('click', () => choose(-1));
    all('[data-step]').forEach((button, i) => button.addEventListener('click', () => {if (button.disabled) return;active = i;render();focusHeading();}));
    one('[data-reset]').addEventListener('click', () => {slots = [null, null, null, null];active = 0;render();focusHeading();});
    one('[data-form]').addEventListener('submit', async event => {
      event.preventDefault();
      const variant = variantFor(slots);
      if (busy || itemCount(slots) < 2 || !variant) return;
      if (!complete(slots)) {slots = slots.map(item=>item===null?-1:item);advance();return;}
      if (cfg.isDraft) {review();return;}
      if (!variant.available) {feedback(s.unavailable, true);return;}
      busy = true;render();
      try {
        const selection = slots.filter(i => i >= 0 && i !== null).map(i => items[i].name).join(' · ');
        const properties = {[s.selection_property]: selection};
        const response = await fetch(cfg.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1,properties}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : s.cart_error);
        window.location.assign(cfg.cartUrl);
      } catch (error) {busy = false;render();feedback(error.message || s.cart_error, true);}
    });
    const initialId = new URL(window.location.href).searchParams.get('variant');
    const initial = [...variants.values()].find(v => v.id === initialId);
    if (initial?.counts && initial.counts.reduce((a, b) => a + b, 0) >= 2) {
      const selected = initial.counts.flatMap((qty, i) => Array(qty).fill(i));
      if (selected.length <= 4) {slots = selected.concat(Array(4 - selected.length).fill(-1));active = 4;}
    }
    render();
  }
  function init() {document.querySelectorAll('[data-dna-mb]').forEach(mount);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dna-product-reviews"] && !Shopify.designMode) return;
  try {
    
  let reviewScrollCorrection;
  document.addEventListener('click', function (event) {
    const link = event.target.closest('#dna-product-review-summary, .dna-product-reviews__back');
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    const offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    if (reviewScrollCorrection) window.removeEventListener('scrollend', reviewScrollCorrection);
    reviewScrollCorrection = function () {
      if (!target.isConnected || location.hash !== link.hash) return;
      const difference = target.getBoundingClientRect().top - offset;
      if (Math.abs(difference) > 2) window.scrollBy({ top: difference, behavior: 'instant' });
    };
    window.addEventListener('scrollend', reviewScrollCorrection, { once: true });
    if (location.hash !== link.hash) history.pushState(null, '', link.hash);
    target.focus({ preventScroll: true });
    window.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dna-home-banners')) {
  customElements.define('dna-home-banners', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track = this.querySelector('.dna-home-banners__track');
      const slides = Array.from(this.querySelectorAll('[data-banner-block]'));
      if (!track || !slides.length) return;
      const abort = new AbortController();
      const listen = (target, name, fn, options = {}) => target.addEventListener(name, fn, {...options, signal: abort.signal});
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, timer = 0, frame = 0, disposed = false;
      const autoplay = this.dataset.autoplay === 'true';
      let pointerActive = false;
      const delay = Math.max(4000, Number(this.dataset.delay) || 4000);
      const running = () => autoplay && !pointerActive && !motion.matches && !document.hidden && !this.contains(document.activeElement);
      const sync = () => {
        slides.forEach((slide, i) => {
          slide.inert = i !== index;
          slide.setAttribute('aria-hidden', String(i !== index));
        });
        const nextImage = slides[(index + 1) % slides.length].querySelector('img');
        if (nextImage) nextImage.loading = 'eager';
      };
      const schedule = () => {
        if (disposed) return;
        clearTimeout(timer);
        sync();
        if (slides.length > 1 && running()) timer = window.setTimeout(() => go(index + 1), delay);
      };
      const go = (next) => {
        const wrap = next < 0 || next >= slides.length;
        index = (next + slides.length) % slides.length;
        track.scrollTo({left: index * track.clientWidth, behavior: motion.matches || wrap ? 'auto' : 'smooth'});
        schedule();
      };
      listen(track, 'keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); go(index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      listen(track, 'pointerdown', () => { pointerActive = true; schedule(); }, {passive: true});
      const releasePointer = () => {
        if (!pointerActive) return;
        pointerActive = false;
        schedule();
      };
      listen(window, 'pointerup', releasePointer, {passive: true});
      listen(window, 'pointercancel', releasePointer, {passive: true});
      listen(track, 'scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const nearest = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
          if (nearest !== index) { index = nearest; schedule(); }
        });
      }, {passive: true});
      listen(this, 'focusin', schedule);
      listen(this, 'focusout', () => queueMicrotask(schedule));
      listen(document, 'visibilitychange', schedule);
      listen(motion, 'change', schedule);
      listen(document, 'shopify:block:select', event => {
        const selected = slides.findIndex(slide => slide.dataset.bannerBlock === event.detail.blockId);
        if (selected >= 0) go(selected);
      });
      const resize = new ResizeObserver(() => {
        track.scrollTo({left: index * track.clientWidth, behavior: 'auto'});
      });
      resize.observe(track);
      this.setAttribute('data-ready', '');
      this.cleanup = () => { disposed = true; clearTimeout(timer); cancelAnimationFrame(frame); abort.abort(); resize.disconnect(); this.removeAttribute('data-ready'); };
      schedule();
    }
    disconnectedCallback() { if (this.cleanup) this.cleanup(); this.cleanup = null; }
  });
}


  } catch(e) { console.error(e); }
})();
})();
